module.exports = __webpack_public_path__ + "static/media/carousal_3_desktop.19f60c0b.jpg";